import { AsyncAction } from './AsyncAction';
import { AsyncScheduler } from './AsyncScheduler';
export const asyncScheduler = new AsyncScheduler(AsyncAction);
export const async = asyncScheduler;
